import { render, staticRenderFns } from "./CompletionMessageStep.vue?vue&type=template&id=5c96e4b0&scoped=true"
import script from "./CompletionMessageStep.vue?vue&type=script&lang=js"
export * from "./CompletionMessageStep.vue?vue&type=script&lang=js"
import style0 from "./CompletionMessageStep.vue?vue&type=style&index=0&id=5c96e4b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c96e4b0",
  null
  
)

export default component.exports